import {define, Record, attr} from "type-r";

@define
class PermitsModel extends Record {
    @attr(false) isAuthenticated: boolean;
    @attr(false) hasSelfProfile: boolean;
    @attr(false) allowedManageProfiles: boolean;
    //  here will be something for other staffs rights
}

export default PermitsModel;


// WEBPACK FOOTER //
// ./src/models/PermitsModel.ts